import {
  fetchingError,
} from '../../../shared/store/actions';
import { YES_FLAG } from '../../../shared/constants';
import { groupTypeValues } from '../../viewTaxExpensePage/constants';

import downloadXlsxETRReport from '../downloadXlsxETRReport';

import {
  SELECT_GROUPTYPE_FOR_ETR,
  SELECT_GROUP_ITEM_FOR_ETR,
  SELECT_GROUPBY_FOR_ETR,
  SELECT_VIEWBY_FOR_ETR,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR_SUCCESS,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR_FAILURE,
  UPDATE_SELECTED_COUNTRY_TAX_TYPES_FOR_ETR,
  UPDATE_STATUTORY_TAX_RATE_FOR_ETR,
  FETCHING_SL_GROUP_TYPES_FOR_ETR,
  FETCHING_SL_GROUP_TYPES_FOR_ETR_SUCCESS,
  FETCHING_SL_GROUP_TYPES_FOR_ETR_FAILURE,
  SAVING_CUSTOM_ETR_DRIVER,
  SAVING_CUSTOM_ETR_DRIVER_SUCCESS,
  SAVING_CUSTOM_ETR_DRIVER_FAILURE,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES_SUCCESS,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES_FAILURE,
  RESET_COUNTRY_TAX_TYPES_AND_RATES,
  FETCHING_ETR_REPORT_DATA,
  FETCHING_ETR_REPORT_DATA_SUCCESS,
  FETCHING_ETR_REPORT_DATA_FAILURE,
  RESET_ETR_REPORT,
  EXPORT_EFFECTIVE_TAX_RATE,
  ETR_TOGGLE_VISIBILITY,
  SELECT_EFFECTIVE_TAX_RATE_CELL_FOR_DETAILS,
  FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE,
  FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_SUCCESS,
  FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_FAILURE,
  RESET_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE,
} from './types';

import { findCompanyCodeInContext } from './helpers';

import {
  fetchGroupItems as fetchGroupItemsApi,
  fetchSlGroupsInitialData as fetchSlGroupsInitialDataApi,
  fetchCompanyCodesForETR as fetchCompanyCodesForETRApi,
  fetchCountryTaxTypesForETR as fetchCountryTaxTypesForETRApi,
  fetchCountryTaxTypesAndRatesForGroup as fetchCountryTaxTypesAndRatesForGroupApi,
  addCustomDriver as addCustomDriverApi,
  fetchTags as fetchTagsApi,
  updateCustomDriver as updateCustomDriverApi,
  deleteCustomDrivers as deleteCustomDriverApi,
  fetchETRReportData as fetchETRReportDataApi,
  fetchCountryTaxTypesForCompanyCode as fetchCountryTaxTypesForCompanyCodeApi,
} from '../../api';

import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import { reportingCurrencyCodeSelector } from '../../../shared/store/selectors';

import getModalActions from '../../../shared/modals/getModalActions';

import ModalNames from '../modalNames';

export const fetchReport = ({
  periodName,
  groupType,
  groupItem,
  groupBy,
  statutoryTaxRate,
  countryTaxTypes,
  detailedCountryTaxTypesData,
}) => async (dispatch, getState) => {
  const reportingCurrencyCode = reportingCurrencyCodeSelector(getState());

  if (!statutoryTaxRate || countryTaxTypes.length === 0) {
    return;
  }

  dispatch({ type: FETCHING_ETR_REPORT_DATA });

  const detailedStatutoryTaxRate = detailedCountryTaxTypesData.find(
    ({ countryTaxTypeWithTaxRate }) => countryTaxTypeWithTaxRate === statutoryTaxRate.value
  );

  const detailedCountryTaxTypes = countryTaxTypes.map(ctt => (
    detailedCountryTaxTypesData.find(
      ({ countryTaxType }) => countryTaxType === ctt.value
    )
  ));

  const statCttRate = [detailedStatutoryTaxRate].map(({ countryTaxType, countryCode, taxRate }) => ({
    country_tax_type: countryTaxType, // eslint-disable-line camelcase
    country_code: countryCode, // eslint-disable-line camelcase
    rate: taxRate,
  }));

  const cttRates = detailedCountryTaxTypes.map(({ countryTaxType, countryCode, taxRate }) => ({
    country_tax_type: countryTaxType, // eslint-disable-line camelcase
    country_code: countryCode, // eslint-disable-line camelcase
    rate: taxRate,
  }));

  const data = {
    periodName,
    groupType,
    groupItem,
    groupBy: groupBy === '' ? groupType : groupBy,
    statCttRate,
    cttRates,
    reportingCurrencyCode,
  };

  try {
    const [reportData, ccs, ETRGroups] = await Promise.all([
      fetchETRReportDataApi(data),
      fetchCompanyCodesForETRApi({ periodName, groupType, groupItem, cttRates }),
      fetchTagsApi(periodName),
    ]);

    const companyCodes = ccs.map(({ companyCode, ctts }) => ({ companyCode, ctts: ctts.split(',') }));

    return dispatch({
      type: FETCHING_ETR_REPORT_DATA_SUCCESS,
      reportData,
      companyCodes,
      ETRGroups,
    });
  } catch (error) {
    dispatch({ type: FETCHING_ETR_REPORT_DATA_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      return dispatch(errorNotification(error.message));
    }
    throw error;
  }
};

export const fetchCountryTaxTypesForCompanyCode = (periodName, companyCode) => async dispatch => {
  const fetchCountryTaxTypesStarted = () => ({
    type: FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE,
  });

  const fetchCountryTaxTypesSuccess = countryTaxTypes => ({
    type: FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_SUCCESS,
    countryTaxTypes,
  });

  const fetchCountryTaxTypesFailure = () => ({
    type: FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_FAILURE,
  });

  dispatch(fetchCountryTaxTypesStarted());

  try {
    const countryTaxTypes = await fetchCountryTaxTypesForCompanyCodeApi(periodName, companyCode);
    dispatch(fetchCountryTaxTypesSuccess(countryTaxTypes));
  } catch (error) {
    dispatch(fetchCountryTaxTypesFailure());
    dispatch(errorNotification(error.message));
  }
};

export const fetchCountryTaxTypesAndRates = ({ periodName, groupType, groupItem }) => async dispatch => {
  dispatch({ type: FETCHING_COUNTRY_TAX_TYPES_AND_RATES });

  try {
    const [countryTaxTypesAndRates, countryTaxTypesETR] = await Promise.all([
      fetchCountryTaxTypesAndRatesForGroupApi({ groupType, groupItem, periodName }),
      fetchCountryTaxTypesForETRApi({ periodName, groupType, groupItem }),
    ]);

    dispatch({
      type: FETCHING_COUNTRY_TAX_TYPES_AND_RATES_SUCCESS,
      countryTaxTypesAndRates,
      countryTaxTypesETR,
    });
  } catch (error) {
    dispatch({
      type: FETCHING_COUNTRY_TAX_TYPES_AND_RATES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectGroupType = groupType => ({
  type: SELECT_GROUPTYPE_FOR_ETR,
  groupType,
});

export const selectGroupItem = groupItem => ({
  type: SELECT_GROUP_ITEM_FOR_ETR,
  groupItem,
});

export const selectGroupBy = groupBy => ({
  type: SELECT_GROUPBY_FOR_ETR,
  groupBy,
});

export const selectViewBy = viewBy => ({
  type: SELECT_VIEWBY_FOR_ETR,
  viewBy,
});

export const resetCountryTaxTypesAndRates = () => ({
  type: RESET_COUNTRY_TAX_TYPES_AND_RATES,
});

export const resetETRReport = () => ({
  type: RESET_ETR_REPORT,
});

export const resetCountryTaxTypesForCompanyCode = () => ({
  type: RESET_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE,
});

export const selectGroupItemForViewEffectiveTaxRatePage = ({
  groupItem,
}) => async (dispatch, getState) => {
  dispatch(selectGroupItem(groupItem));
  dispatch(resetCountryTaxTypesAndRates());
  dispatch(resetETRReport());

  if (groupItem) {
    const { groupType } = getState().reports.effectiveTaxRate;
    const periodName = getState().shared.period.name;

    dispatch(fetchCountryTaxTypesAndRates({ periodName, groupType, groupItem: groupItem.value }));
  }
};

export const fetchSlGroupItems = groupType => async (dispatch, getState) => {
  dispatch({ type: FETCHING_SL_GROUP_ITEMS_FOR_ETR });

  try {
    const groupItems = await fetchGroupItemsApi({ groupType });
    const groupItem = findCompanyCodeInContext({ groupType, groupItems, state: getState() });

    dispatch({
      type: FETCHING_SL_GROUP_ITEMS_FOR_ETR_SUCCESS,
      groupItems,
    });
    dispatch(selectGroupItemForViewEffectiveTaxRatePage({ groupItem }));
  } catch (error) {
    dispatch({
      type: FETCHING_SL_GROUP_ITEMS_FOR_ETR_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectGroupTypeForViewEffectiveTaxRatePage = ({
  groupType,
}) => async dispatch => {
  dispatch(selectGroupType(groupType));
  dispatch(fetchSlGroupItems(groupType));
};

export const fetchInitialData = ({ periodName }) => async dispatch => {
  dispatch({ type: FETCHING_SL_GROUP_TYPES_FOR_ETR });

  try {
    const { groupTypes } = await fetchSlGroupsInitialDataApi({ periodName });
    const groupTypesWithoutCustomGroups = groupTypes.filter(({ value }) => value !== groupTypeValues.CUSTOM_GROUP);
    const defaultGroupType = groupTypesWithoutCustomGroups.find(groupType => groupType.defaultFlag === YES_FLAG);
    if (defaultGroupType && defaultGroupType.value) {
      dispatch(selectGroupTypeForViewEffectiveTaxRatePage({ groupType: defaultGroupType.value }));
    }

    const groupByOptions = [
      { name: 'None', value: '', defaultFlag: YES_FLAG },
      ...groupTypesWithoutCustomGroups,
    ];

    dispatch({
      type: FETCHING_SL_GROUP_TYPES_FOR_ETR_SUCCESS,
      groupTypes,
      groupByOptions,
    });
  } catch (error) {
    dispatch({
      type: FETCHING_SL_GROUP_TYPES_FOR_ETR_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectCountryTaxType = ({
  periodName,
  groupType,
  groupItem,
  groupBy,
  statutoryTaxRate,
  countryTaxTypes,
  detailedCountryTaxTypesData,
}) => async dispatch => {
  dispatch(fetchReport({
    periodName,
    groupType,
    groupItem,
    groupBy,
    statutoryTaxRate,
    countryTaxTypes,
    detailedCountryTaxTypesData,
  }));

  return dispatch({
    type: UPDATE_SELECTED_COUNTRY_TAX_TYPES_FOR_ETR,
    countryTaxTypes,
  });
};

export const selectStatutoryTaxRate = ({
  periodName,
  groupType,
  groupItem,
  groupBy,
  statutoryTaxRate,
  countryTaxTypes,
  detailedCountryTaxTypesData,
}) => async dispatch => {
  dispatch(fetchReport({
    periodName,
    groupType,
    groupItem,
    groupBy,
    statutoryTaxRate,
    countryTaxTypes,
    detailedCountryTaxTypesData,
  }));

  dispatch({
    type: UPDATE_STATUTORY_TAX_RATE_FOR_ETR,
    statutoryTaxRate,
  });
};

export const addCustomETRDriver = ({ data }) => async dispatch => {
  dispatch({ type: SAVING_CUSTOM_ETR_DRIVER });

  try {
    await addCustomDriverApi(data);
    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_SUCCESS });
    dispatch(successNotification('New custom ETR driver has been saved'));
  } catch (error) {
    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const updateCustomETRDriver = ({
  oldEntry,
  newEntry,
}) => async dispatch => {
  dispatch({ type: SAVING_CUSTOM_ETR_DRIVER });

  try {
    await updateCustomDriverApi({ oldEntry, newEntry });

    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_SUCCESS });
    dispatch(successNotification('Custom ETR driver has been updated'));
  } catch (error) {
    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const deleteCustomETRDriver = ({ periodName, manualEntryId }) => async dispatch => {
  dispatch({ type: SAVING_CUSTOM_ETR_DRIVER });

  try {
    await deleteCustomDriverApi({ periodName, manualEntryId });

    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_SUCCESS });
    dispatch(successNotification('Custom ETR driver has been deleted'));
  } catch (error) {
    dispatch({ type: SAVING_CUSTOM_ETR_DRIVER_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const {
  showAction: showDeletingDriverModal,
  hideAction: hideDeletingDriverModal,
} = getModalActions(ModalNames.ConfirmDeletingDriver);

export const exportToExcel = ({
  period,
  groupType,
  slGroupItem,
  reportingCurrencyCode,
  countryTaxTypes,
  statutoryTaxRate,
  reportData,
  displayGroupingColumnsByPercentages,
  totalColumnName = 'Total',
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,
}) => async dispatch => {
  dispatch({
    type: EXPORT_EFFECTIVE_TAX_RATE,
  });

  const countryTaxTypesToRender = countryTaxTypes.map(countryTaxType => countryTaxType.label).join(',');

  const fileName = `TLS_ETR_${period.name}_${slGroupItem.value}_${reportingCurrencyCode}${environmentSuffix}`;
  const description = `${period.name}, ${groupType}, ${slGroupItem.value}, Country Tax Types: ${countryTaxTypesToRender}, Statuatory Tax Rate: ${statutoryTaxRate.label}, Currency: ${reportingCurrencyCode}`;

  downloadXlsxETRReport({
    reportData,
    description,
    fileName,
    totalColumnName,
    displayGroupingColumnsByPercentages,
    hideDecimals,
    negativeMinus,
    shouldDisplayZero,
  });
};

export const toggleVisibility = path => ({
  type: ETR_TOGGLE_VISIBILITY,
  path,
});

export const selectEffectiveTaxRateCellForDetails = selectedCell => ({
  type: SELECT_EFFECTIVE_TAX_RATE_CELL_FOR_DETAILS,
  selectedCell,
});
